import type { EventBus } from '../core/EventBus';

export class ControlPanelVisibilityHotkey {
  constructor(
    private eventBus: EventBus,
    private playerRoot: HTMLElement,
  ) {
    this.playerRoot.addEventListener('keydown', this.onKeyDown);
  }

  private onKeyDown = (e: KeyboardEvent): void => {
    if (!e.ctrlKey || e.altKey || e.metaKey || e.shiftKey) return;
    if (e.code !== 'KeyD') return;

    const target = e.target as HTMLElement;
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.tagName === 'SELECT') return;

    this.eventBus.emit('controls:visibility:toggle');
    e.preventDefault();
    e.stopPropagation();
  };

  destroy(): void {
    this.playerRoot.removeEventListener('keydown', this.onKeyDown);
  }
}